/**
 * @description 문자열에 허용된 문자(한글, 영문, 숫자, 기호)만 있는지 체크하는 함수
 * @returns boolean, (true: 허용하는 문자로만 이루어짐, false: 허용하지 않는 문자열 포함)
 */

const validateAuthOwnerName = (str: string) => {
  const regex =
    /^[a-zA-Z\d가-힣ㄱ-ㅎㅏ-ㅣᄀᄂᄃᄅᄆᄇᄉᄋᄌᄎᄏᄐᄑᄒᆞ\u318D\u11A2\u2022\u2025\u00B7\uFE55\uFE52!@#$%^&*()-_=+|[\]{};:,.<>/?]*$/;

  return regex.test(str);
};

export default validateAuthOwnerName;
